import { ReactNode } from 'react'
import { Skeleton } from '@systemeio/components'
import { twMerge } from 'tailwind-merge'
import { addPublicCustomClassNamePrefix } from '../utils/add-class-prefix'

export const CourseContentSkeleton = ({ className }: { className?: string }): ReactNode => (
  <Skeleton
    className={twMerge(
      'h-[80vh] w-full',
      className,
      addPublicCustomClassNamePrefix('course__content-skeleton'),
    )}
  />
)
